import React, { Children } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion } from 'framer-motion';
export function IdentificationSection() {
  const painPoints = ['Te cuesta soltar el control.', 'Sientes que si no lo haces tú, no se hace bien.', 'Tu mente nunca para.', 'Estás cansada, pero no sabes descansar.', 'En tus relaciones, terminas liderando todo.', 'Sientes que cargas con todo y nadie lo nota.'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-87">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <FadeIn data-id="element-89">
          <div className="text-center mb-16" data-id="element-90">
            <h2 className="text-3xl md:text-4xl font-serif text-brown leading-relaxed" data-id="element-91">
              Estás agotada porque llevas años operando desde un lugar que no te
              corresponde.
            </h2>
          </div>
        </FadeIn>

        <div className="bg-cream/50 rounded-3xl p-8 md:p-12 border border-gold/10 shadow-xl shadow-brown/5" data-id="element-92">
          <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="space-y-6 mb-12" data-id="element-93">
            {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="flex items-start" data-id="element-94">
                <div className="flex-shrink-0 mt-1.5 mr-4 w-2 h-2 rounded-full bg-gold" data-id="element-95" />
                <p className="text-xl text-brown/80 leading-relaxed font-serif italic" data-id="element-96">
                  {point}
                </p>
              </motion.li>)}
          </motion.ul>

          <FadeIn delay={0.8} data-id="element-97">
            <div className="pt-8 border-t border-gold/20 text-center" data-id="element-98">
              <p className="text-2xl md:text-3xl font-serif text-gold-dark font-bold" data-id="element-99">
                No estás rota. Estás desconectada de tu energía natural.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}